import Select from "react-select";

import PropTypes from "prop-types";

const optionDatatypes = {
  value: PropTypes.string,
  label: PropTypes.string,
};

function SortBySelect({ options, defaultValue, value, onChange, className }) {
  return (
    <div className={`${className} items-center gap-[0.3rem] md:gap-[1rem] `}>
      <p className="text-[0.938rem] leading-[1.375rem] text-grayDisplay-300">
        Sort By
      </p>
      <Select
        options={options}
        defaultValue={defaultValue}
        value={value}
        instanceId={"sort"}
        clearIndicator
        className="w-[8rem] md:w-[12.5rem]"
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderRadius: "2.5rem",
            height: "2.75rem",
            border: 0,
            boxShadow: "none",
            paddingLeft: "0.75rem",
          }),

          container: (baseStyles) => ({
            ...baseStyles,
            border: "1px solid #1F2A3B",
            borderRadius: "2.5rem",
          }),

          dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            color: "#414E5F",
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            width: "100%",
            borderRadius: "5px",
            marginTop: "5px",
            background: state.isFocused ? "#F1F3F6" : "white",
            color: "black",
            cursor: "pointer",
            marginBottom: state.options.length === 5 ? "10px" : "",
          }),
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: "12px",
          colors: {
            ...theme.colors,
            primary25: "#F1F3F6",
            primary50: "#F1F3F6",
            primary: "#F1F3F6",
            color: "black",
          },
        })}
        components={{
          IndicatorSeparator: () => null,
        }}
        isSearchable={false}
        onChange={onChange}
      />
    </div>
  );
}

SortBySelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape(optionDatatypes)).isRequired,
  defaultValue: PropTypes.shape(optionDatatypes),
  value: PropTypes.shape(optionDatatypes),
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default SortBySelect;
